import request from "../common/request";
import queryString from "query-string";

const getSearchResults = (query, currentLocation) => {
    var params = {
        q: query,
    };

    if ( currentLocation != null ) {
        params = Object.assign({}, params, {
            lat: currentLocation.lat ?? "",
            lng: currentLocation.lng ?? ""
        });
    }

    const result = request
        .get("/api/search")
        .query(params)
        .set("Accept", "application/json, text/javascript");
    return result;
};

const loadFilters = () => {
    const result = request.get("/api/filters").set("Accept", "application/json, text/javascript");
    return result;
};

const getToursByLocation = (location) => {
    const { province, city, sector, lat, lng, type } = queryString.parse(location.search);

    const result = request
        .get("/api/virtual-tour/search")
        .query({
            province,
            city,
            sector,
            type,
            lat,
            lng
        })
        .set("Accept", "application/json, text/javascript");
    return result;
};

export { getSearchResults, loadFilters, getToursByLocation };
